<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Faq</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Faq</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Faq</h5>
            <span :class="chevronMainClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddFaq" to="/faq/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @expand-row="editFaq"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #expand>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div
                            class="ibox-title"
                            @click="isPlEditOpen = !isPlEditOpen"
                          >
                            <h5>Opis faq [pl]</h5>
                            <span
                              :class="chevronPlEditClass"
                              class="ibox-toggle"
                            ></span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isPlEditOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Tytuł
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    id="username"
                                    v-model="faqObj.title_pl"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Tytuł"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.title_pl"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.title_pl[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="faqObj.description_pl"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.description_pl"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{
                                        errorsAdminData.data.description_pl[0]
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div
                            class="ibox-title"
                            @click="isEnEditOpen = !isEnEditOpen"
                          >
                            <h5>Opis faq [en]</h5>
                            <span
                              :class="chevronEnEditClass"
                              class="ibox-toggle"
                            ></span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isEnEditOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Tytuł
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="faqObj.title_en"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Tytuł"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.title_en"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.title_en[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="faqObj.description_pl"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.description_pl"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{
                                        errorsAdminData.data.description_pl[0]
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div
                            class="ibox-title"
                            @click="isDeEditOpen = !isDeEditOpen"
                          >
                            <h5>Opis faq [de]</h5>
                            <span
                              :class="chevronDeEditClass"
                              class="ibox-toggle"
                            ></span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isDeEditOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Tytuł
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="faqObj.title_de"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Tytuł"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.title_de"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.title_de[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="faqObj.description_de"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.description_de"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{
                                        errorsAdminData.data.description_de[0]
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div
                            class="ibox-title"
                            @click="isDeDeEditOpen = !isDeDeEditOpen"
                          >
                            <h5>Opis faq [de_de]</h5>
                            <span
                              :class="chevronDeDeEditClass"
                              class="ibox-toggle"
                            ></span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isDeDeEditOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Tytuł
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="faqObj.title_cpde"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Tytuł"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.title_cpde"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.title_cpde[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="faqObj.description_cpde"
                                  />
                                  <div
                                    v-if="
                                      errorsAdminData?.data?.description_cpde
                                    "
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{
                                        errorsAdminData.data.description_cpde[0]
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div
                            class="ibox-title"
                            @click="isDeEnEditOpen = !isDeEnEditOpen"
                          >
                            <h5>Opis faq [de_en]</h5>
                            <span
                              :class="chevronDeEnEditClass"
                              class="ibox-toggle"
                            ></span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isDeEnEditOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Tytuł
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="faqObj.title_cpen"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Tytuł"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.title_cpen"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.title_cpen[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="faqObj.description_cpen"
                                  />
                                  <div
                                    v-if="
                                      errorsAdminData?.data?.description_cpen
                                    "
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{
                                        errorsAdminData.data.description_cpen[0]
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div
                            class="ibox-title"
                            @click="isConfigEditOpen = !isConfigEditOpen"
                          >
                            <h5>Dane faq</h5>
                            <span
                              :class="chevronConfigEditClass"
                              class="ibox-toggle"
                            ></span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isConfigEditOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Sekcja
                                </label>
                                <div class="col-sm-10">
                                  <Multiselect
                                    v-model="faqObj.section"
                                    mode="single"
                                    placeholder="Sekcja"
                                    track-by="name"
                                    label="name"
                                    :close-on-select="false"
                                    :searchable="true"
                                    :options="faqSections"
                                  >
                                  </Multiselect>
                                  <div
                                    v-if="errorsAdminData?.data?.section"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.section[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="hr-line-dashed"></div>

                              <div class="form-group">
                                <div class="col-sm-4 col-sm-offset-2">
                                  <button class="btn btn-white" @click="cancel">
                                    Anuluj
                                  </button>
                                  <button
                                    v-if="canChangeFaq"
                                    @click="saveEdit"
                                    class="btn btn-primary"
                                  >
                                    Zapisz
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #item-section="item">{{ item.section }}</template>
                  <template #item-actions="item">
                    <button
                      v-if="canDeleteFaq"
                      @click.stop="
                        showModal = item.pk;
                        deleteName = item.title;
                      "
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteFaq(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Modal from "../caffeprint/Modal.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { hasPermission } from "../../permissions";
import { faqPermissionsConst } from "../../constants/settingConstants";

export default {
  name: "FaqList",
  mixins: [],
  components: {
    Modal,
    Multiselect,
  },
  props: {},

  setup() {
    const store = useStore();
    const canAddFaq = computed(() => hasPermission(faqPermissionsConst.add));
    const canChangeFaq = computed(() =>
      hasPermission(faqPermissionsConst.update)
    );
    const canDeleteFaq = computed(() =>
      hasPermission(faqPermissionsConst.delete)
    );
    const deleteFaqData = computed(() => store.getters.getDeleteFaqData);
    const faqData = computed(() => store.getters.getFaqData);
    const updateFaqData = computed(() => store.getters.getUpdateFaqData);
    const faqsData = computed(() => store.getters.getFaqsData);
    const faqObj = ref({
      title: "",
      section: "",
    });
    let headers = [
      { text: "Nr", value: "pk" },
      { text: "Nazwa", value: "title", sortable: true, search: true },
      { text: "Sekcja", value: "section", sortable: true, search: true },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: false,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: false,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let statsItems = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const defRowsPerPage = ref(25);
    const isMainOpen = ref(true);
    const isPlEditOpen = ref(true);
    const isEnEditOpen = ref(true);
    const isDeEditOpen = ref(true);
    const isDeDeEditOpen = ref(true);
    const isDeEnEditOpen = ref(true);
    const isConfigEditOpen = ref(true);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
    });

    const getFaqs = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getFaqs", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const deleteFaq = (pk) => {
      showModal.value = false;
      if (!canDeleteFaq.value) {
        return;
      }
      store.dispatch("deleteFaq", {
        pk: pk,
      });
    };
    const saveEdit = () => {
      if (!canChangeFaq.value) {
        return;
      }
      store.dispatch("updateFaq", faqObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editFaq = (globalIndex) => {
      cancel();
      const localIndex =
        globalIndex - (serverOptions.value.page - 1) * defRowsPerPage.value;
      store.dispatch("getFaq", { pk: items.value[localIndex].pk });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getFaqs();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getFaqs();
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const updateSort = () => {
      search.value = true;
    };

    const faqSections = ref([
      {
        name: "1",
        value: "SECTION_ORDER",
      },
      {
        name: "2",
        value: "SECTION_PAYMENT",
      },
      {
        name: "3",
        value: "SECTION_DELIVERY",
      },
    ]);

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("faqsSearchValue") !== null) {
        searchValue.value = localStorage.getItem("faqsSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      getFaqs();
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "faqsSearchValue",
          JSON.stringify(searchValue.value)
        );
        getFaqs();
      },
      { deep: true }
    );

    watch(
      () => faqsData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => faqData.value,
      function (newValue) {
        faqObj.value = newValue.data;
      }
    );

    watch(
      () => deleteFaqData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Faq został usunięty",
          });
        }
        getFaqs();
      }
    );

    watch(
      () => updateFaqData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getFaqs();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getFaqs();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      canAddFaq,
      canChangeFaq,
      canDeleteFaq,
      headers,
      items,
      itemsAll,
      loading,
      serverOptions,
      showModal,
      deleteFaq,
      deleteName,
      statsItems,
      faqObj,
      cancel,
      editFaq,
      saveEdit,
      searchValue,
      search,
      resetFilters,
      updateSort,
      isSearch,
      rowsPerPage,
      faqSections,
      selectPage,
      setRowsPerPage,
      isMainOpen,
      isPlEditOpen,
      isEnEditOpen,
      isDeEditOpen,
      isDeDeEditOpen,
      isDeEnEditOpen,
      isConfigEditOpen,
    };
  },
  computed: {
    chevronMainClass() {
      return this.isMainOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronPlEditClass() {
      return this.isPlEditOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronEnEditClass() {
      return this.isEnEditOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronDeEditClass() {
      return this.isDeEditOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronDeDeEditClass() {
      return this.isDeDeEditOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronDeEnEditClass() {
      return this.isDeEnEditOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
    chevronConfigEditClass() {
      return this.isConfigEditOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}
</style>
